<template>
    <div>
        <Toolbar>
            <BackButton to="Inventory upload" :href="$route('stocks.upload')"/>
        </Toolbar>

        <Card>
            <template v-slot:icon>
                <i class="fas fa-upload text-3xl"/>
            </template>
            <template v-slot:title>
                Submit inventory for {{ store.attributes.name }}
            </template>
            <template v-slot:description>
                Map the headers of your file to the mandatory columns.
            </template>
            <template v-slot:toolbar>
                <StoreImage :store="store" class="h-3em w-100px" />
            </template>

            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label class="font-weight-bold">Identifier type</label>
                        <select class="form-control form-control-solid" v-model="form.identifier_type">
                            <option v-for="(identifierFullName, identifierType) in identifierTypes"
                                    :value="identifierType"
                            >
                                {{ identifierType }} ({{ identifierFullName }})
                            </option>
                        </select>
                        <span class="form-text text-muted">
                            Specify the primary identifier.
                            Use GTIN/EAN if available, else SKU.
                            For Google Merchant Center using GTIN or EAN is mandatory.
                        </span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label class="font-weight-bold">Null old inventory?</label>
                        <Checkbox type="danger" v-model="form.null_old">
                            Yes, set quantity to zero on all existing inventory.
                        </Checkbox>
                        <span class="form-text text-muted">
                            This will set the quantity to zero for all stock items that are no more present in the submitted file.
                        </span>
                    </div>
                </div>
            </div>
        </Card>

        <Card class="mt-3">
            <StockMappingTable :example-values="firstRow"
                               :identifier-type="form.identifier_type"
                               v-model="form.mapping"
            />
        </Card>

        <Card class="mt-3">
            <div class="d-flex flex-row">
                <div class="flex-grow-1">
                </div>
                <div class="d-flex flex-row gap-3 align-items-center">
                    <div>
                        <span v-if="!allFieldsMapped" class="text-muted">
                            You need to map all selected fields, before you can continue.
                        </span>
                    </div>
                    <div>
                        <button v-if="!loading"
                            class="btn btn-primary px-20"
                                :disabled="!allFieldsMapped"
                                @click="submit">
                            <i class="fas fa-arrow-right"/>
                            Start Import
                        </button>
                        <div v-else class="spinner spinner-primary mr-10"/>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>

import StoreImage from "@components/Store/StoreImage.vue";
import StockMappingTable from "@components/Stock/Components/StockMappingTable.vue";
import BackButton from "@components/BackButton.vue";
import Badge from "@components/Badge.vue";
import Checkbox from "@components/Form/Checkbox.vue";
import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";

export default {
    components: {StoreImage, StockMappingTable, BackButton, Toolbar, Badge, Checkbox, Card},

    props: {
        defaultIdentifier: String,
        uploadSessionId: String,
        firstRow: Object,
        store: Object,
        mapping: Object,
    },

    data() {
        return {
            identifierTypes: {
                'EAN': 'European Article Number',
                'GTIN': 'Global Trade Item Number',
                'SKU': 'Stock Keeping Unit',
            },
            form: this.$inertia.form({
                store_uuid: this.store.id,
                identifier_type: null,
                mapping: this.mapping || {},
                temp: this.temp,
                null_old: false
            }),
            iteration: 0,
            loading: false
        }
    },

    mounted() {
        if (this.defaultIdentifier) {
            this.form.identifier_type = this.defaultIdentifier.toUpperCase()
        }
    },

    methods: {
        submit() {
            this.loading = true;
            this.form.post(this.$route('stocks.upload.submit', [this.uploadSessionId]).url());
        },
    },

    computed: {
        allFieldsMapped() {
            // for (let field of Object.keys(this.form.mapping)) {
            //     if (this.form.mapping[field] === null || this.form.mapping[field].length === 0) {
            //         return false;
            //     }
            // }

            return true;
        }
    }
}
</script>
